type CommerceItems = {
  skuId: string;
  quantity: number;
}[];

export type ApiResponse = {
  success: boolean;
  commerceItems: CommerceItems;
};

export class ApiResponseFactory {
  static failureResponse(): ApiResponse {
    return {
      success: false,
      commerceItems: [],
    };
  }
}

export async function addM2MProductToBasket(
  baseUrl: string,
  quantity: number,
  skuId: string,
  variantId: string,
  configurationType: string,
  configuration: object,
): Promise<ApiResponse> {
  const { url, options } = await requestBuilder(
    baseUrl,
    quantity,
    skuId,
    variantId,
    configurationType,
    configuration,
  );

  let response;
  try {
    response = await fetch(url, options);
  } catch (err) {
    return ApiResponseFactory.failureResponse();
  }

  const { status } = response;

  if (status >= 200 && status <= 299) {
    const commerceItems: CommerceItems = await response
      .json()
      .then((r) => r.basket.commerceItems);
    return {
      success: true,
      commerceItems,
    };
  } else {
    return ApiResponseFactory.failureResponse();
  }
}

async function requestBuilder(
  baseUrl: string,
  quantity: number,
  skuId: string,
  variantId: string,
  configurationType: string,
  configuration: object,
) {
  const body = { quantity, skuId, variantId, configurationType, configuration };
  const auth0 = () => window.__auth0__ || window.auth0;
  const token = await auth0()?.getTokenIfAuthenticated();
  const clientId = "web_pdp_scaffold_ui";
  const url = `${baseUrl}/items/${variantId}`;

  const reqHeaders = new Headers();
  reqHeaders.append("Content-Type", "application/json");
  reqHeaders.append("x-api-client-id", `${clientId}`);
  if (token) {
    reqHeaders.append("Authorization", `Bearer ${token}`);
  }

  const options: RequestInit = {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body),
    headers: reqHeaders,
  };

  return { url, options };
}
